import React, { useState } from 'react'

import { FilterModalService } from '../containers/FilterModalService'

import { FilterModal } from './FilterModal'

export const FilterModalLoader = () => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false)
  const { shouldDisplayFilterModal } = FilterModalService.useContainer()

  if (shouldDisplayFilterModal && !isLoaded) setIsLoaded(true)

  return isLoaded ? <FilterModal /> : null
}
